/**
 * 在途监管平台 — 格式化工具
 */
import {
  AlertHandleMap,
  AlertLevelMap,
  AlertTypeMap,
  ArchiveStatusMap,
  CertVerifyMap,
  CertTypeMap,
  FenceTypeMap,
  QuarantineStatusMap,
  TransitStatusMap,
} from '@/types';

/** ISO 时间 → 本地可读时间 */
export function fmtTime(value?: string | null): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  const pad = (n: number): string => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** 相对时间（如 5 分钟前） */
export function timeAgo(value?: string | null): string {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  const diff = Date.now() - d.getTime();
  if (diff < 0) return '刚刚';
  const min = Math.floor(diff / 60000);
  if (min < 1) return '刚刚';
  if (min < 60) return `${min} 分钟前`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h} 小时前`;
  const day = Math.floor(h / 24);
  return `${day} 天前`;
}

export function transitStatusText(status: number): string {
  return TransitStatusMap[status] ?? '未知';
}

export function quarantineStatusText(status: number): string {
  return QuarantineStatusMap[status] ?? '未知';
}

export function alertTypeText(type: number): string {
  return AlertTypeMap[type] ?? '未知';
}

export function alertLevelText(level: number): string {
  return AlertLevelMap[level] ?? '—';
}

export function alertHandleText(status: number): string {
  return AlertHandleMap[status] ?? '未知';
}

export function fenceTypeText(type: number): string {
  return FenceTypeMap[type] ?? '未知';
}

export function certVerifyText(status: number): string {
  return CertVerifyMap[status] ?? '未知';
}

export function certTypeText(type: number): string {
  return CertTypeMap[type] ?? '未知';
}

export function archiveStatusText(status: number): string {
  return ArchiveStatusMap[status] ?? '未知';
}

/** 告警级别 CSS 变量名 */
export function alertLevelTone(level: number): string {
  switch (level) {
    case 1:
      return 'amber';
    case 2:
      return 'orange';
    case 3:
      return 'red';
    default:
      return 'muted';
  }
}

/** 短哈希展示 */
export function shortHash(hash?: string): string {
  if (!hash) return '—';
  if (hash.length <= 24) return hash;
  return `${hash.slice(0, 12)}…${hash.slice(-8)}`;
}
